module.exports = __webpack_public_path__ + "NanumSquareB.ada293a44f5ee12a368f";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareB.woff
// module id = ../../../../../src/assets/font/NanumSquareB.woff
// module chunks = styles